import { nudgeActions } from '../actions/'
import { nudgeMutations } from '../mutations/'

export default {
  state: {
    messages: {},
    queryCount: '',
    responseMessage: {},
    allNudges: [],
    aNudge: {}
  },
  mutations: nudgeMutations,
  actions: nudgeActions
}



// WEBPACK FOOTER //
// ./src/store/modules/nudge.js